import {forEach} from "../helpers";
import Bouncer from '../bouncer'
import { validateConfig } from "../validateConfig";
import axios from "axios";

export function registerUser(form, type) {
    let params = {};
    forEach(form.elements, el => {
      if (!el.name) return;
      params[el.name] = el.value
    });
      params['CONFIRM_PASSWORD'] = params['PASSWORD'];
      params['UF_PASSWORD'] = params['PASSWORD'];

    axios.post('/api/v1/user/', params)
      .then(response => {
        if (!response.data.success) throw response.data.errors[0].message;
        console.log(response);
        form.classList.remove('is-loading');
        form.dispatchEvent(new CustomEvent("user-hidden-register", {'detail': {USER_ID: response.data.data.USER_ID}}));
      })
      .catch(error => {
        console.log(error);
        form.classList.remove('is-loading');
        if (error === 'Пользователь уже зарегистрирован') {
          const fieldEmail = form.elements['EMAIL'];
          const attr = fieldEmail.getAttribute('data-bouncer-exclude');
          fieldEmail.setAttribute('data-bouncer-exclude', attr === null ? fieldEmail.value : attr + ' ' + fieldEmail.value);
          new Bouncer().validate(form.elements['EMAIL'], validateConfig);
        }
      });
}
